module.exports = __webpack_public_path__ + "img/pic_popup_profileinfoincomplete.2244f48d.png";